module.exports = {
  "colorPrimary": "#D10A60",
  "colorPrimaryDark": "#B80954",
  "colorPrimaryDarker": "#A00849",
  "colorPrimaryLight": "#D94D89",
  "colorSecondary": "#E4E4E4",
  "colorSecondaryDark": "#D9D9D9",
  "colorSecondaryDarker": "#D3D3D3",
  "colorSecondaryLight": "#F2F2F2",
  "colorSecondaryLighter": "#F9F9F9",
  "colorInitial": "#AEAEAE",
  "colorOk": "#00CC66",
  "colorPending": "#FFCC00",
  "colorError": "#ED1C24",
  "colorErrorLight": "#EB5757",
  "backgroundControl": "#FFFFFF",
  "backgroundDefault": "#F2F2F2",
  "backgroundDarkMode": "#302934",
  "backgroundPrimary": "#D10A60",
  "backgroundPrimaryHover": "#B80954",
  "backgroundPrimaryActive": "#A00849",
  "backgroundPrimaryDisabled": "#D94D89",
  "backgroundSecondary": "#E4E4E4",
  "backgroundSecondaryHover": "#D9D9D9",
  "backgroundSecondaryActive": "#D3D3D3",
  "backgroundSecondaryDisabled": "#F2F2F2",
  "backgroundHighlight": "#EBF0F8",
  "backgroundInitial": "#E4E4E4",
  "backgroundOk": "#A3E8B2",
  "backgroundPending": "lighten(@color-pending, 30%)",
  "backgroundError": "#F8AAAD",
  "backgroundAgendaBlue": "#3467BB",
  "backgroundInitialContrast": "#E4E4E4",
  "backgroundOkContrast": "#00CC66",
  "backgroundPendingContrast": "#FFCC00",
  "backgroundErrorContrast": "#ED1C24",
  "fontColorDefault": "#373737",
  "fontColorPrimary": "#FFFFFF",
  "fontColorPrimaryDisabled": "rgba(255,255,255,0.30)",
  "fontColorSecondary": "#373737",
  "fontColorSecondaryDisabled": "#AEAEAE",
  "fontColorInline": "#797979",
  "fontColorInlineDisabled": "#AEAEAE",
  "fontColorInitial": "#AEAEAE",
  "fontColorOk": "#4FB070",
  "fontColorPending": "#FFCC00",
  "fontColorError": "#ED1C24",
  "fontColorInitialContrast": "contrast(@background-initial-contrast, @font-color-default, @font-color-primary, 45%)",
  "fontColorOkContrast": "contrast(@background-ok-contrast, @font-color-default, @font-color-primary, 45%)",
  "fontColorPendingContrast": "contrast(@background-pending-contrast, @font-color-default, @font-color-primary, 45%)",
  "fontColorErrorContrast": "contrast(@background-error-contrast, @font-color-default, @font-color-primary, 45%)",
  "fontColorLink": "#3366BB",
  "fontColorHint": "#999999",
  "fontColorPale": "#515151",
  "lineHeightDefault": "1.2; // according to https://developer.mozilla.org/en/docs/Web/CSS/line-height\r\n@line-height-title:1.4",
  "fontSizeReallySmall": "9px",
  "fontSizeMinorDetails": "11px",
  "fontSizeSmall": "13px",
  "fontSizeNormal": "14px",
  "fontSizeMedium": "16px",
  "fontSizeBig": "18px",
  "fontSizeReallyBig": "22px",
  "fontSizeHuge": "28px",
  "fontSizeEnormous": "36px",
  "fontWeightLight": "300",
  "fontWeightNormal": "400",
  "fontWeightSemiBold": "600",
  "fontWeightBold": "700",
  "fontFamilyButton": "Roboto, sans-serif",
  "fontFamilyNormal": "Open Sans, sans-serif",
  "naturalIconSize": "14px",
  "iconSizeSmaller": "ceil(@natural-icon-size * 0.75)",
  "iconSizeNormal": "14px",
  "iconSizeMedium": "ceil(@natural-icon-size * 1.25)",
  "iconSizeBig": "round(@natural-icon-size * 1.5)",
  "iconSizeBigger": "floor(@natural-icon-size * 1.75)",
  "heatScaleColor1": "#00A651",
  "heatScaleColor2": "#7CC576",
  "heatScaleColor3": "#FFC062",
  "heatScaleColor4": "#F26C4F",
  "heatScaleColor5": "#ED1C24",
  "meetingStatusColor1": "#FF7050",
  "meetingStatusColor2": "#00CC66",
  "meetingStatusColor3": "#FFCC00",
  "meetingStatusColor4": "#D3D3D3",
  "strategyActionTypeColor1": "#FF7050",
  "strategyActionTypeColor2": "#3366BB",
  "strategyActionTypeColor3": "#1D7775",
  "strategicConnectionIconColorDescription": "#8DA593",
  "strategicConnectionIconColorGoal": "#F2A88C",
  "strategicConnectionIconColorMilestone": "#D98282",
  "strategicConnectionIconColorProgram": "#81B7FF",
  "strategicConnectionIconColorSelection": "#F4C080",
  "agendaTimeReservationIconColor": "#9575CC",
  "meetingIconColor": "#FEC972",
  "workshopIconColor": "#E57373",
  "mindmapIconColor": "#0F8DE9",
  "dialogIconColor": "#FF8A66",
  "commonHorizontalMargin": "10px",
  "commonVerticalMargin": "10px",
  "commonMargin": "10px 10px",
  "commonHorizontalPadding": "10px",
  "commonVerticalPadding": "10px",
  "commonPadding": "10px 10px",
  "gutterWidth": "15px",
  "commonShadowX": "0px",
  "commonShadowY": "1px",
  "commonShadowOffset": "0px 1px",
  "commonShadowBlur": "3px",
  "commonShadowColor": "rgba(0, 0, 0, 0.2)",
  "commonShadowColorHover": "rgba(0, 0, 0, 0.4)",
  "hoverShadowTransition": "box-shadow .2s ease",
  "mapChartLinkCurveColor": "#B1B1B1",
  "textHorPadding": "5px",
  "textVertPadding": "0",
  "borderColorDefault": "#E4E4E4",
  "borderRadiusDefault": "2px",
  "borderWidthDefault": "1px",
  "buttonHeight": "28px",
  "buttonVertPadding": "5px",
  "buttonHorPadding": "14px",
  "{selector}": "not([disabled]),\r\n    > @{selector}:hover:not([disabled]),\r\n    > @{selector}.hover:not([disabled]),\r\n    > @{selector}:active:not([disabled]),\r\n    > @{selector}.active:not([disabled]),\r\n    > @{selector}:focus:not([disabled]),\r\n    > @{selector}.focus:not([disabled]),\r\n    > @{selector}[disabled] {\r\n        @styles()",
  "inputHorPadding": "5px",
  "inputVertPadding": "3px",
  "radioCheckboxSize": "18px",
  "radioCheckboxMargin": "10px",
  "radioCheckboxBorderWidth": "1px",
  "rangeTrackColor": "#D3D3D3",
  "rangeThumbColor": "#D10A60",
  "rangeTrackHeight": "2px",
  "rangeThumbSize": "16px",
  "margin, @prop": "margin) {\r\n    & > * {\r\n        .vert-list-item(@margin, @prop)",
  "supports(display": "flex) {\r\n        margin-left:@margin-left",
  "mobileWidth": "530px",
  "tabletWidth": "950px",
  "desktopWidth": "1366px",
  "desktopXlWidth": "1920px",
  "desktopXxlWidth": "2880px",
  "mobile": "~\"only screen and (max-width:529px)\"",
  "tablet": "~\"only screen and (min-width:530px) and (max-width:949px)\"",
  "desktop": "~\"only screen and (min-width:950px) and (max-width:1365px)\"",
  "desktopXl": "~\"only screen and (min-width:1366px)\"",
  "desktopXxl": "~\"only screen and (min-width:1920px)\""
};
